export const DEFAULT_CLINIC_IMAGE = '/images/defaults/clinic_default.jpg';
export const DEFAULT_DOCTOR_MALE_IMAGE = '/images/defaults/doctor_male.png';
export const DEFAULT_DOCTOR_FEMALE_IMAGE = '/images/defaults/doctor_female.png';

export const normalizeGender = (value) => {
  const normalized = (value || '').trim().toLowerCase();
  if (
    normalized === 'female' ||
    normalized === 'f' ||
    normalized === 'woman' ||
    normalized === 'أنثى' ||
    normalized === 'انثى'
  ) {
    return 'female';
  }

  return 'male';
};

export const getDefaultDoctorImage = (gender) =>
  normalizeGender(gender) === 'female'
    ? DEFAULT_DOCTOR_FEMALE_IMAGE
    : DEFAULT_DOCTOR_MALE_IMAGE;

export const handleImageFallback = (fallbackSrc, fallbackClassName = '') => (event) => {
  const image = event.currentTarget;
  if (!fallbackSrc || image.dataset.fallbackApplied === 'true') {
    return;
  }

  image.dataset.fallbackApplied = 'true';
  if (fallbackClassName) {
    image.className = fallbackClassName;
  }
  image.src = fallbackSrc;
};
